module.exports = function getResource(label, vars = []) {
    const resources = {
        challengerOneHeader: `Want to Earn ${vars[0]} Points?`,
        challengerOneMessage: 'Sign in to bank them for this purchase.',
        challengerTwoHeader: 'Want Free Shipping?',
        challengerTwoMessage: 'Sign in to get free shipping for this purchase.',
        signInText: 'Sign In'
    };

    return resources[label];
};
